module.exports = __webpack_public_path__ + "static/media/FlyingBoids.4c184f29.svg";